import styled from "../_snowpack/pkg/@emotion/styled.js";
import React from "../_snowpack/pkg/react.js";
import ProcessNavi from "./process-navi.js";
import CartSidebar from "./cart-sidebar.js";
import {t} from "../common/i18n.js";
import Stack from "./stack.js";
import MainSidebarContainer from "./main-sidebar-container.js";
import {getUrl} from "../common/universal.js";
import {Routes} from "../typings/routes.js";
import {withAttrs} from "../common/utils.js";
import {useCartStore} from "../stores/cart.js";
export default function CartContainer(props) {
  const {activeUrl, children, sidebarButtons, user, spacing, ...rest} = props;
  const {cart} = useCartStore();
  const steps = [
    {
      text: t("Bestellübersicht"),
      url: getUrl(Routes.cartRenderCustomerCart)
    },
    {
      text: t("Daten"),
      url: getUrl(Routes.cartAddCustomerInformation)
    },
    {
      text: t("Versand"),
      url: getUrl(Routes.cartGetShipping)
    },
    {
      text: t("Bestätigen"),
      url: getUrl(Routes.cartReviewOrder)
    }
  ];
  const canLogin = !user && !cart.create_shop_account;
  if (canLogin) {
    steps.splice(1, 0, {
      text: t("Login"),
      url: getUrl(Routes.cartLogin)
    });
  }
  const activeStep = findIndexBy(steps, (s) => s.url === activeUrl);
  return /* @__PURE__ */ React.createElement(Container, {
    isCart: true,
    main: /* @__PURE__ */ React.createElement(Main, {
      spacing: spacing ? spacing : "xxl"
    }, /* @__PURE__ */ React.createElement(ProcessNavi, {
      activeStep,
      steps
    }), /* @__PURE__ */ React.createElement(Inner, null, children)),
    sidebar: /* @__PURE__ */ React.createElement(CartSidebar, {
      buttons: sidebarButtons
    }),
    ...rest
  });
}
function findIndexBy(arr, by) {
  for (let i = 0; i < arr.length; i++) {
    if (by(arr[i]))
      return i;
  }
  return -1;
}
const Container = styled(MainSidebarContainer)``;
const Main = styled(Stack)`
  padding-top: 64px;
`;
const Inner = styled(withAttrs(Stack, {spacing: "l"}))``;
